
import "../css/NavBar.css";

const WebFooter = () =>{
    return(
        <div className="footer">
            <div style={{display:"flex", justifyContent:'center', alignItems:"center", height:"100%"}}>
                <img src="/assets/homepage/slimeville_logo_footer.png"  style={{margin:"50px"}}/>
            </div>
        </div>
    );
}

export default WebFooter;